import CaregiverCreate from './CaregiverCreate';
import CaregiverEditContact from './CaregiverEditContact';
import CaregiverEditName from './CaregiverEditName';
import CaregiverEditStatus from './CaregiverEditStatus';
import CaregiverRemoveContact from './CaregiverRemoveContact';

const UPDATE_TYPES = {
  'CAREGIVER_CREATE': {
    title: 'caregiver.CaregiverDetail.Correspondance.Correspondance.Logs.CreatedOn',
    component: CaregiverCreate,
  },
  'CAREGIVER_EDIT_NAME': {
    title: 'caregiver.CaregiverDetail.Correspondance.Correspondance.Logs.EditName',
    component: CaregiverEditName,
  },
  'CAREGIVER_EDIT_STATUS': {
    title: 'caregiver.CaregiverDetail.Correspondance.Correspondance.Logs.EditStatus',
    component: CaregiverEditStatus,
  },
  'CAREGIVER_EDIT_CONTACT': {
    title: 'caregiver.CaregiverDetail.Correspondance.Correspondance.Logs.EditContact',
    component: CaregiverEditContact,
  },
  'CAREGIVER_REMOVE_CONTACT': {
    title: 'caregiver.CaregiverDetail.Correspondance.Correspondance.Logs.RemoveContact',
    component: CaregiverRemoveContact,
  },
};

export {
  UPDATE_TYPES,
};
